module.exports = __webpack_public_path__ + "static/media/gastrokrym.1bdaa03c.jpg";